import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { UserDTO } from '@glowearth/shared/types';

export interface UserState {
  user: UserDTO | null;
  token: string | null;
  isLoading: boolean;
  error: string | null;

  setUser: (user: UserDTO | null) => void;
  setToken: (token: string | null) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  updatePoints: (freePoints: number, paidPoints: number) => void;
  clearUser: () => void;
}

export const useUserStore = create<UserState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      isLoading: false,
      error: null,

      setUser: (user) => set({ user }),
      setToken: (token) => set({ token }),
      setLoading: (isLoading) => set({ isLoading }),
      setError: (error) => set({ error }),
      updatePoints: (freePoints, paidPoints) =>
        set((state) => ({
          user: state.user
            ? { ...state.user, free_points: freePoints, paid_points: paidPoints }
            : null,
        })),
      clearUser: () => set({ user: null, token: null, error: null }),
    }),
    {
      name: 'glowearth-user',
      partialize: (state) => ({ user: state.user, token: state.token }),
    }
  )
);
